import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const solutions = [
  { title: "Hospital Management System", desc: "Patient registration, appointment scheduling, billing, and medical records." },
  { title: "AI Appointment Bot", desc: "WhatsApp and voice-based appointment booking that works 24/7." },
  { title: "Patient CRM", desc: "Track patient journeys, follow-ups, and communication in one place." },
  { title: "Telemedicine Platform", desc: "Video consultation, prescription management, and payment integration." },
];

const Healthcare = () => (
  <StitchFeaturePage
    label="INDUSTRIES / HEALTHCARE"
    title="Patient systems as"
    titleAccent="reliable as your practice."
    subtitle="Hospital management, patient CRM, and AI assistants for clinics and healthcare groups."
    features={solutions}
    ctaLabel="BUILD FOR HEALTHCARE"
  />
);

export default Healthcare;
